import { Injectable } from '@angular/core';
import { RxdbInitializerService } from './rxdb-initializer.service';

@Injectable({
    providedIn: 'root'
})
export class RxdbControlFunctionsService {

    constructor(private _rxdbInitializerService: RxdbInitializerService)
    {
    }

    public async truncateAllDbData() {
        // await removeRxDatabase(this._rxdbInitializerService.dbName, getRxStorageDexie());
        await this._rxdbInitializerService.truncateAllDbData();
    }
}
